import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment-jalali';
import Time from './Time';
import { DatePicker } from 'components/datepicker';
import Field from './FieldContainer';

const Wrapper = styled.div`
  margin-bottom: 20px;
  padding-left: 10px;

  input {
    display: block;
    position: relative;
    width: 100%;
    background: #ffffff;
    border: 1px solid #d5d5d5;
    border-radius: 2px;
    font-size: 12px;
    line-height: 1.75;
    padding: 4px 15px;
    -webkit-transition: all 50ms linear;
    transition: all 50ms linear;
    direction: ltr;
    text-align: left;
  }
`;

const Right = styled.div`
  float: right;
  width: 65%;
`;

const Left = styled.div`
  float: right;
  width: 35%;
`;

export default class DateTime extends React.Component {
  static propTypes = {
    help: PropTypes.node,
    tip: PropTypes.node,
    required: PropTypes.bool,
    datePlaceholder: PropTypes.string,
    timePlaceholder: PropTypes.string,
    defaultTime: PropTypes.string,
    minDate: PropTypes.object,
    maxDate: PropTypes.object
  };

  static defaultProps = {
    defaultTime: ''
  };

  state = {
    date: null,
    time: '',
    hideCalendar: false
  };

  timeInput = null;
  datePickerInput = null;

  componentDidMount() {
    this.setValueFromProps(this.props.value);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setValueFromProps(nextProps.value);
    }
  }

  setValueFromProps(value) {
    const { onChange } = this.props;

    if (value) {
      const datetime = moment(value);
      const formatted = datetime.format('YYYY-MM-DD HH:mm');

      if (datetime.isValid()) {
        if (onChange && value !== formatted) {
          onChange(formatted);
        }

        this.setState({
          date: datetime,
          time: datetime.format('HH:mm')
        });
      }
    }
  }

  handleDateChange = date => {
    this.setState(
      {
        date
      },
      () => {
        this.handleChange(date, this.state.time);
      }
    );
  };

  handleTimeChange = time => {
    this.setState(
      {
        time
      },
      () => {
        this.handleChange(this.state.date, time);
      }
    );
  };

  handleChange = (date = this.state.date, time = this.state.time) => {
    const { defaultTime, onChange } = this.props;
    const formatted =
      date && date.isValid && date.isValid()
        ? `${date.format('YYYY-MM-DD')} ${time || defaultTime}`
        : '';

    onChange(formatted);

    // this.focusTimeInput(); temporary comment to don't scroll to that position
  };

  handleDatePickerInputRef = node => {
    this.datePickerInput = node;
  };

  handleTimeInputRef = node => {
    this.timeInput = node;
  };

  focusTimeInput() {
    this.timeInput.focus();
    this.setState({
      hideCalendar: true
    });
  }

  render() {
    const { timePlaceholder, minDate, maxDate } = this.props;
    const { date, time, hideCalendar } = this.state;

    return (
      <Field {...this.props}>
        <Wrapper className=" form-field form-datetime">
          <Right>
            <div className="date-input-container">
              <div className="form-field form-text form-date">
                <DatePicker
                  onChange={this.handleDateChange}
                  inputRef={this.handleDatePickerInputRef}
                  value={date}
                  hideCalendar={hideCalendar}
                  min={minDate}
                  max={maxDate}
                />
              </div>
            </div>
          </Right>
          <Left>
            <Time
              placeholder={timePlaceholder}
              handleTimeInputRef={this.handleTimeInputRef}
              input={{
                onChange: this.handleTimeChange,
                value: time
              }}
            />
          </Left>
        </Wrapper>
      </Field>
    );
  }
}
